import React, { useState, useEffect } from 'react';
import axios from "axios";
import avatar from 'assets/img/default.jpg';
import './MyProfile.scss'
import toast, { Toaster } from 'react-hot-toast';



export default function MyProfile() {
    const emptyForm = {
      first_name: '', 
      last_name: '', 
      email: '', 
      company: '', 
      country: '', 
      date_of_birth: '', 
      change_password: false, 
      password_old: '', 
      password_new: '', 
      password_new_confirm: ''
    }
    const [profile, setProfile] = useState(emptyForm)
    const [newProfile, setNewProfile] = useState(emptyForm)
    const [isEditing, setIsEditing] = useState(false);
    const [matchingPwd, setMatchingPwd] = useState(true);
    const [missingPwd, setMissingPwd] = useState(false)
    const [licenses, setLicenses] = useState(0)
    const [units, setUnits] = useState(0)

    const fixDate = (rawDate) => {
        return new Date(rawDate).toISOString().split('T')[0]
    }

    const API = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL,
      withCredentials: true,
    });

    async function getProfileData() {
      try {
        const resLicenses = await API.post("/users/licenses/count");
        const resUnits = await API.post("/units/my-units");
        const resProfile = await API.post("/users/profile");

        setLicenses(resLicenses.data);
        setUnits(resUnits.data);
        if (resProfile.data.date_of_birth) {
          resProfile.data.date_of_birth = fixDate(resProfile.data.date_of_birth)
        } 
        setProfile(resProfile.data);
        setNewProfile({...emptyForm, ...profile})

      } catch (error) {
        console.log(error.response.data);
        toast.error(error.response.data)
      }
    }

    const updateProfile = async (e) => {
        e.preventDefault();

        API.post("/users/profile/update", newProfile )
        .then(response => {
          toast.success("Profile saved")
          setIsEditing(false);
          getProfileData();
        })
        .catch(error => {
          console.log("error:", error.response.data)
          toast.error(error.response.data)
        });
    };
    
    useEffect(() => {
        getProfileData();
    }, []);

    useEffect(() => {
        if (newProfile.password_new === newProfile.password_new_confirm && 
            newProfile.password_new !== "" && 
            newProfile.password_new_confirm !== "" ) {
            setMatchingPwd(true)
        }
        if (newProfile.password_old !== "" && missingPwd) {
            setMissingPwd(false)
        }

    }, [newProfile]);

    const checkValues = (e) => {

        if (newProfile.password_new_confirm === "" &&
            newProfile.password_new === "" && 
            newProfile.password_old === "") {
                newProfile.change_password = false;
            }
        let valuesValid = true;

        if (newProfile.change_password) {
            if (newProfile.password_old !== "" && (newProfile.password_new !== newProfile.password_new_confirm || (newProfile.password_new === "" && newProfile.password_new_confirm === ""))) {
                toast.error("New passwords missing or doesn't match")
                setMatchingPwd(false)
                valuesValid = false;
            } 
            if (newProfile.password_old === "" && (newProfile.password_new !== "" || newProfile.password_new_confirm !== "")) {
                toast.error("Old password missing")
                setMissingPwd(true)
                valuesValid = false;
            }
        }
        if (valuesValid) {
            updateProfile(e)
        }
    }

    const toggleEdit = () => {
        setIsEditing(!isEditing);
        setMatchingPwd(true)
        setMissingPwd(false)
        setNewProfile({...profile, change_password: false, password_old: '', password_new: '', password_new_confirm: ''})
    }



    return (
      
<div>

    <div>
        <Toaster
            position="top-right"
            reverseOrder={false}
        />
    </div>

  <div className="header pb-6">
    <div className="container-fluid">
      <div className="header-body">
        <div className="row align-items-center py-4">
          <div className="col-lg-6 col-7">
            <h2 className="h2 d-inline-block mb-0">My Profile</h2>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="container-fluid mt--6" style={{minHeight: '100vh'}}>

    <div className="row">

      <div className="col-md-4">
        <div className="card card-profile">
          <div className="profilebg"></div>
          <div className="row justify-content-center">
            <div className="col-lg-3 order-lg-2">
              <div className="card-profile-image">
                <div className="avatar-edit" style={{display:'none'}}>
                  <input type="file" id="avatar" name="avatar" accept=".png, .jpg, .jpeg" />
                  <label htmlFor="avatar"></label>
                </div>
                <img className="avatar-preview" id="imagePreview" src={avatar} />
              </div>
            </div>
          </div>

          <div className="card-footer" style={{borderTop: 'none !important'}}>
            <hr />
            <div className="button-container">
              <div className="row" style={{justifyContent: 'space-between'}}>
                <div className="col-md-6 col-6 text-left">
                  <h1>
                    {licenses}
                    <br />
                    <small>Licenses</small>
                  </h1>
                </div>
                <div className="col-lg-4 col-md-6 col-6 text-right">
                  <h1>
                    {units}
                    <br />
                    <small>Units</small>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-8">

        <div className={`card ${ isEditing ? 'd-none' : ''}`} id="show" style={{padding: '30px'}}>
          <div className="pr-1 pl-0">
            <div className="form-group">
              <label className="label" data-locale="First Name">First Name:&nbsp;</label>
              <label className="font-weight-bold">{profile.first_name}</label>
            </div>
          </div>
          <div className="pr-1 pl-0">
            <div className="form-group">
              <label className="label" data-locale="Last Name">Last Name:&nbsp;</label>
              <label className="font-weight-bold">{profile.last_name}</label>
            </div>
          </div>
          <div className="row"></div>
          <div className="pr-1 pl-0">
            <div className="form-group">
              <label className="label" data-locale="Email">Email:&nbsp;</label>
              <label className="font-weight-bold">{profile.email}</label>
            </div>
          </div>
          <div className="pr-1 pl-0">
            <div className="form-group">
              <label className="label" data-locale="Company Name">Company Name:&nbsp;</label>
              <label className="font-weight-bold">{profile.company}</label>
            </div>
          </div>
          <div className="row"></div>
          <div className="pr-1 pl-0">
            <div className="form-group">
              <label className="label" data-locale="Country Name">Country Name:&nbsp;</label>
              <label className="font-weight-bold">{profile.country}</label>
            </div>
          </div>
          <div className="pr-1 pl-0">
            <div className="form-group">
              <label className="label" data-locale="Date of birth">Date Of birth:&nbsp;</label>
              <label className="font-weight-bold">{profile.date_of_birth}</label>
            </div>
          </div>
          <div className="row"></div>
          <div className="pr-1">
            <div className="form-group">
              <button className="btn btn-success" id="btnEdit" data-locale="Edit"  onClick={toggleEdit}>Edit</button>
            </div>
          </div>
        </div>

        <div id="edit" className={`card ${ isEditing ? '' : 'd-none'}`} style={{padding: '30px'}}>
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col-8">
                <h3 className="mb-0">Edit profile </h3>
              </div>
            </div>
          </div>
          <div className="card-body">
            <form className="form-horizontal" method="POST">
{/*             <input type="hidden" name="_token" value="LYjImkRPQ2YBB6L6iavQYkVgyCNe9rpk1d4JHjjf" />*/} 
{/*             <input type="hidden" name="id" value="43" /> */} 
              <div className="pl-lg-4">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="control-label" htmlFor="first_name" data-locale="First Name">First Name</label>
                      <input type="text" className="form-control" id="first_name" name="first_name" placeholder="First Name" 
                      onChange={(e) => setNewProfile({...newProfile, first_name: e.target.value})} value={newProfile.first_name} />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="control-label" htmlFor="last_name" data-locale="Last Name">Last Name</label>
                      <input type="text" className="form-control" id="last_name" name="last_name" placeholder="Last Name" 
                      onChange={(e) => setNewProfile({...newProfile, last_name: e.target.value})} value={newProfile.last_name} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="pl-lg-4">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="control-label" htmlFor="email" data-locale="Email">Email</label>
                      <input type="text" className="form-control"  id="email" name="email" placeholder="Email" readOnly={true} defaultValue={newProfile.email} />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="control-label" htmlFor="company_name" data-locale="Company Name">Company Name</label>
                      <input type="text" className="form-control" id="company_name" name="company" placeholder="Company Name" 
                      onChange={(e) => setNewProfile({...newProfile, company: e.target.value})} value={newProfile.company} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="pl-lg-4">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="control-label" htmlFor="country_name" data-locale="Country Name">Country Name</label>
                      <input type="text" className="form-control" id="country_name" name="country" placeholder="Country Name" 
                      onChange={(e) => setNewProfile({...newProfile, country: e.target.value})} value={newProfile.country} />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="control-label" htmlFor="birth" data-locale="Date of birth">Date Of birth</label>
                      <input type="text" className="form-control" id="birth" name="date_of_birth" placeholder="Date Of Birth" readOnly={true} defaultValue={newProfile.date_of_birth} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="pl-lg-4">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                        <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" id="changePassword"
                        onChange={(e) => setNewProfile({...newProfile, change_password: !newProfile.change_password})} checked={newProfile.change_password}/>
                        <label className="control-label form-check-label" htmlFor="changePassword">Change Password
                        </label>
                        </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className={`form-group ${ newProfile.change_password ? '' : 'd-none'}`}>
                      <label className="control-label" data-locale="Confirm Password" autoComplete="old-password">Old Password</label>
                      <input type="password" className={`form-control ${ missingPwd ? 'input-error' : ''}`} name="old_password" placeholder="Old Password" autoComplete="on" 
                      onChange={(e) => setNewProfile({...newProfile, password_old: e.target.value})} value={newProfile.password_old}/>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`pl-lg-4 ${ newProfile.change_password ? '' : 'd-none'}`}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="control-label" data-locale="Change Password" autoComplete="new-password">New Password</label>
                      <input type="password" className={`form-control ${ matchingPwd ? '' : 'input-error'}`} name="new_password" placeholder="New Password" autoComplete="off" 
                      onChange={(e) => setNewProfile({...newProfile, password_new: e.target.value})} value={newProfile.password_new} />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="control-label" data-locale="Confirm Password" autoComplete="new-password">Confirm New Password</label>
                      <input type="password" className={`form-control ${ matchingPwd ? '' : 'input-error'}`} name="new_password_confirmation" placeholder="Confirm New Password" autoComplete="off" 
                      onChange={(e) => setNewProfile({...newProfile, password_new_confirm: e.target.value})} value={newProfile.password_new_confirm}/>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pl-lg-4">
                <div className="form-group">
                  <div className="">
                    <button type="button" className="btn btn-success" id="btnSave" data-locale="Save" onClick={(e) => checkValues(e)}>Save</button>
                    <button className="btn btn-success d-none" type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span className="sr-only">Saving...</span>
                    </button>
                    <button type="button" className="btn btn-default" id="btnCancel" data-locale="Cancel" onClick={toggleEdit}>Cancel</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>
    )
};